import _ from 'lodash';
import { SubmissionError, change } from 'redux-form';
import { processSubmissionErrors } from '../../shared-components/FormElement/FormElementUtils';
import { spinnerClose } from '../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { scrollToTop } from '../../framework/App/SkeletonPage/SkeletonPageActions';
import { FORM_FIELDS } from '../config/form';
import { PAGE_NAME } from '../config/pageNames';
import { push } from 'connected-react-router';
import { safeStringify } from '../../shared-utilities/safeStringify';

export const isSoftDecline = (state) => {
    const showValidationSoftDecline = _.get(state, 'serverData.showValidationSoftDecline', false);
    const softDeclineMsg = _.get(state, 'serverData.softDeclineMsg', false);
    const softDeclineCustomMsg = _.get(state, 'serverData.softDeclineCustomMsg', false);
    return showValidationSoftDecline || softDeclineMsg || softDeclineCustomMsg;
};

/**
 * When there is a validation error due to PO Box / PMB / delivery service done on server side by ANS (T2), the server data is set with showDeliveryAddressValidationError=true
 * @param state to retrieve showDeliveryAddressValidationError value  from
 * @return {*} true if showDeliveryAddressValidationError is set or false
 */
export const isDeliveryAddressValidationError = (state) => {
    const showDeliveryAddressValidationError = _.get(state, 'serverData.showDeliveryAddressValidationError', false);
    return showDeliveryAddressValidationError;
};

export const isElementInViewport = (id) => {
    const el = document.getElementById(id);
    const bounding = el && el.getBoundingClientRect() || {};
    const elMinHeight = bounding.top;
    const elMaxHeight = bounding.top + bounding.height;
    const windowHeight = document.documentElement.clientHeight || window.innerHeight;

    if (windowHeight > elMaxHeight) {
        return 'Visible';
    } else if (windowHeight === elMaxHeight) {
        return 'Visible';
    } else if (elMinHeight < windowHeight && windowHeight < elMaxHeight) {
        return 'PartiallyVisible';
    } else {
        return 'Hidden';
    }
};

/**
 * helper function called in handleServerSideErrors() which takes you to the
 * page of the first form field error
 * @param {*} dispatch redux dispatch
 * @param {*} getState redux getState
 * @param {*} response ajax response after submitting a form
 */
export const gotoPageWithFieldError = async(dispatch, getState, response) => {
    const errorFieldKeys = _.keys(_.get(response, 'data.validation.errors.fieldError'));
    const firstErrorField = _.head(errorFieldKeys);
    if (_.includes(FORM_FIELDS.BILLING_INFO, firstErrorField)) {
        await dispatch(push(PAGE_NAME.BILLING_PAGE));
    } else if (_.includes(FORM_FIELDS.PERSONAL_INFO, firstErrorField)) {
        await dispatch(push(PAGE_NAME.PERSONAL_INFO_PAGE));
    }
};

/**
 * when we evaluate an ajax response after a redux-form submit, we should call this
 * function.  it will evaluate whether or not the server-side thinks there are field
 * level validation errors. if there are, we return a redux-form SubmissionError
 * @param {*} dispatch redux dispatch
 * @param {*} getState redux getState
 * @param {*} response ajax response after submitting a form
 */
export const handleServerSideErrors = async(dispatch, getState, response) => {
    const localePrefix = 'US/validations/ServerSide';
    if (!_.isEmpty(_.get(response, 'data.validation.errors'))) {
        dispatch(scrollToTop());
        dispatch(spinnerClose());
        capeLog && capeLog(`handleServerSideErrors:us:response:${safeStringify(response.data.validation.errors)}`);
        await gotoPageWithFieldError(dispatch, getState, response);
        throw new SubmissionError(processSubmissionErrors(response.data.validation.errors.fieldError, localePrefix), getState());
    }
};
